import axios from 'axios';
import { handleApiError } from '../utils/errorHandler';
import { getAccessToken, getUserInfo, triggerLogout } from '@/auth/sessionManager';

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

axiosClient.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const userInfo = await getUserInfo();
    const email = (userInfo as { email?: string; sub?: string } | undefined)?.email;

    if (email) {
      config.headers['x-user-email'] = email;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      await triggerLogout(); 
      return Promise.reject(error);
    }

    handleApiError(error);
    return Promise.reject(error);
  }
);

export default axiosClient;
